


































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { Debounce } from "vue-debounce-decorator";

@Component({})
export default class Documentacion extends Vue {
  private documentos: any = [];
  private currentPage = 1;
  private total = 0;
  private mostrar = false;

  private nivel1Options = [{ value: -1, label: "Todos" }];
  private dataNivel1 = { value: -1, label: "Todos" };
  private nivel2Options = [{ value: -1, label: "Todos" }];
  private nivel2: any = [];
  private dataNivel2 = { value: -1, label: "Todos" };
  private disableNivel2 = true;
  private nivel3Options = [{ value: -1, label: "Todos" }];
  private nivel3: any = [];
  private dataNivel3 = { value: -1, label: "Todos" };
  private disableNivel3 = true;

  @Watch("currentPage")
  private currentPageWatch(newValue: any) {
    if (newValue >= 0 && newValue <= Math.ceil(this.total / 12)) {
      this.getDocumentacion();
    }
  }
  @Watch("dataNivel1")
  private dataNivel1Watch(newValue: any) {
    if (newValue.value != -1) {
      let temp: any = [{ value: -1, label: "Todos" }];
      this.nivel2.map(el => {
        if (el.id_nivel1 == newValue.value) {
          temp.push(el);
        }
      });
      this.nivel2Options = [...temp];
      this.dataNivel2 = { value: -1, label: "Todos" };
      this.disableNivel2 = false;
      this.dataNivel3 = { value: -1, label: "Todos" };
      this.nivel3Options = [...[{ value: -1, label: "Todos" }]];
      this.disableNivel3 = true;
    } else {
      this.nivel2Options = [...[{ value: -1, label: "Todos" }]];
      this.disableNivel2 = true;
      this.dataNivel3 = { value: -1, label: "Todos" };
      this.nivel3Options = [...[{ value: -1, label: "Todos" }]];
      this.disableNivel3 = true;
    }
    this.getDocumentacion();
  }
  @Watch("dataNivel2")
  private dataNivel2Watch(newValue: any) {
    if (newValue.value != -1) {
      let temp: any = [{ value: -1, label: "Todos" }];
      this.nivel3.map(el => {
        if (el.id_nivel2 == newValue.value) {
          temp.push(el);
        }
      });
      this.nivel3Options = [...temp];
      this.dataNivel3 = { value: -1, label: "Todos" };
      this.disableNivel3 = false;
    } else {
      this.nivel3Options = [...[{ value: -1, label: "Todos" }]];
      this.disableNivel3 = true;
    }
    this.getDocumentacion();
  }
  @Watch("dataNivel3")
  private dataNivel3Watch(newValue: any) {
    this.getDocumentacion();
  }

  private mounted() {
    this.getDocumentacion();
    this.getNiveles();
  }

  @Debounce(400)
  private getDocumentacion() {
    this.$q.loading.show({
      delay: 100 // ms
    });
    this.$axios
      .get(
        "documentos/transparencia?pagina=" +
          this.currentPage +
          "&nivel1=" +
          this.dataNivel1.value +
          "&nivel2=" +
          this.dataNivel2.value +
          "&nivel3=" +
          this.dataNivel3.value
      )
      .then((res: any) => {
        if (res.data.documentos.length == 0) {
          this.mostrar = true;
        } else {
          this.mostrar = false;
        }
        this.documentos = res.data.documentos;
        this.total = res.data.total;
        this.$q.loading.hide();
      })
      .catch((err: any) => {
        this.mostrar = true;
        this.documentos = [];
        this.total = 0;
        this.$q.loading.hide();
        console.log(err);
      });
  }
  private getNiveles() {
    this.$q.loading.show({
      delay: 100 // ms
    });
    this.$axios
      .get("niveles")
      .then((res: any) => {
        this.nivel1Options = [...this.nivel1Options, ...res.data.nivel_1];
        this.nivel2Options = [...this.nivel2Options, ...res.data.nivel_2];
        this.nivel3Options = [...this.nivel3Options, ...res.data.nivel_3];
        this.nivel2 = [...res.data.nivel_2];
        this.nivel3 = [...res.data.nivel_3];
        this.$q.loading.hide();
      })
      .catch((err: any) => {
        this.$q.loading.hide();
        console.log(err);
      });
  }

  private toLink(item: any, target: any) {
    if (item && item != "") {
      window.open("https://docs.munijf.cl/" + item, target);
    } else {
      return;
    }
  }
}
